import React, { useState } from "react";

const InfoPopup = ({ isOpen, onClose, exampleAnswer }) => {
  const [copyStatus, setCopyStatus] = useState("");

  const copyToClipboard = () => {
    navigator.clipboard.writeText(exampleAnswer).then(() => {
      setCopyStatus("Copied to Clipboard!");
      setTimeout(() => {
        setCopyStatus("");
      }, 2500);
    });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full">
        <h3 className="text-lg font-semibold mb-4">Example Answer</h3>
        <p className="text-sm text-gray-700 mb-4">{exampleAnswer}</p>
        <button
          onClick={copyToClipboard}
          className="bg-[#F16745] text-white px-4 py-2 rounded-md mr-2"
        >
          {copyStatus || "Copy to Clipboard"}
        </button>
        <button
          onClick={onClose}
          className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default InfoPopup; 